// extracted by mini-css-extract-plugin
export default {"page":"EZ-z","cartModal":"FZ-z","checkout":"GZ-z","placeholder":"HZ-z","account":"IZ-z"};